import { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import AuthContext from "../context/auth/AuthContext";

const EmployeeRoute = () => {
  const { isEmployee } = useContext(AuthContext);
  return isEmployee ? <Outlet /> : <Navigate to="/" replace />;
};

export default EmployeeRoute;
